import { ThemeOptions } from '@mui/material/styles';

import { cssVars } from '../../../utils/cssVars';
import { tokens } from '../../../theme/generated/tokens';

const progressBarWithLabelVars = cssVars(
  {
    gap: undefined,
  },
  'ds-progress-bar-with-label'
);

export const progressBarTheme: ThemeOptions['components'] = {
  MuiLinearProgress: {
    styleOverrides: {
      barColorPrimary: {
        backgroundColor: tokens.theme.bg.status.infoStrong,
      },
      barColorSecondary: {
        backgroundColor: tokens.theme.bg.status.successStrong,
      },

      bar: {
        borderRadius: '24px',
        '.DSuiProgressBar-disabled &': {
          backgroundColor: tokens.theme.disabled.bgStrong,
        },
      },
      root: {
        borderRadius: '24px',
        height: 'var(--ProgressBarHeight)',
        backgroundColor: tokens.theme.bg.structural.surfaceRaised,

        '&.DSuiProgressBar-disabled ': {
          backgroundColor: tokens.theme.disabled.bg,
        },

        '& .MuiLinearProgress-barColorTertiary': {
          backgroundColor: tokens.theme.bg.status.neutralStrong,
        },

        '& .MuiLinearProgress-barColorError': {
          backgroundColor: tokens.theme.bg.status.errorStrong,
        },

        '&.DSuiProgressBar-size-xl': {
          '--ProgressBarHeight': '16px',
        },
        '&.DSuiProgressBar-size-lg': {
          '--ProgressBarHeight': '8px',
        },
        '&.DSuiProgressBar-size-md': {
          '--ProgressBarHeight': '4px',
        },
        '&.DSuiProgressBar-size-sm': {
          '--ProgressBarHeight': '2px',
        },
      },
    },
  },
  DsProgressBarWithLabel: {
    styleOverrides: {
      root: {
        display: 'grid',
        alignItems: 'center',
      },
      startAdornment: {
        gridTemplateColumns: 'max-content auto',
      },
      endAdornment: {
        gridTemplateColumns: 'auto max-content',
      },
      bothAdornments: {
        gridTemplateColumns: 'max-content auto max-content',
      },
      xl: ({ theme }) => ({
        ...progressBarWithLabelVars.setValues({ gap: '16px' }),
        ...theme.typography.P16M,
      }),
      lg: ({ theme }) => ({
        ...progressBarWithLabelVars.setValues({ gap: '12px' }),
        ...theme.typography.P14M,
      }),
      md: ({ theme }) => ({
        ...progressBarWithLabelVars.setValues({ gap: '8px' }),
        ...theme.typography.P12M,
      }),
      sm: ({ theme }) => ({
        ...progressBarWithLabelVars.setValues({ gap: '8px' }),
        ...theme.typography.P10M,
      }),
      startAdornmentWrapper: {
        paddingRight: progressBarWithLabelVars.getters.gap(),
      },
      endAdornmentWrapper: {
        paddingLeft: progressBarWithLabelVars.getters.gap(),
      },
    },
  },
};
